$(document).ready(function () {

    // Header
    function clampMegaMenu($menu) {
        $menu.css('transform', 'translateX(0)');
        const rect = $menu[0].getBoundingClientRect();
        const vw = window.innerWidth;
        const padding = 16;
        let shiftX = 0;

        if (rect.right > vw - padding) {
            shiftX = vw - rect.right - padding;
        }

        if (rect.left < padding) {
            shiftX = padding - rect.left;
        }
        $menu.css('transform', `translateX(${shiftX}px)`);
    }


    $('.site-header .site-nav__details').on('click', function () {
        clampMegaMenu($(this).find('.megumenu'));
        $(this).find('.megamenu-wrap').removeClass('submenu-open');
        $(this).find('.megamenu').removeClass('image-view').find('.media-block').addClass('hide');
    });

    $('.site-nav__dropdown-link--top-level.has-child').click(function(e){
        e.preventDefault();
        var handle = $(this).data('handle');
        $(this).addClass('active').siblings('.site-nav__dropdown-link--top-level').removeClass('active');
        $(this).parents('.megamenu-wrap').addClass('submenu-open');
        $(this).parents('.megamenu-wrap').find('.child-menu-wrap .sub-menu-wrap[data-menu="'+ handle +'"]').show().siblings('.sub-menu-wrap').hide();
        $(this).parents('.megamenu').removeClass('image-view').find('.media-block').addClass('hide')
    });

    $('.megamenu-columns.child-menu-wrap .site-nav__dropdown-link').mouseenter(function(){
        if($(this).attr('data-image')){
            $(this).parents('.megamenu').addClass('image-view');
            $(this).parents('.megamenu-columns.child-menu-wrap').find('.media-block').removeClass('hide').attr('href',$(this).attr('href')).find('img').attr('src',$(this).data('image'));
            const $menu = $(this).closest('.megamenu');
            requestAnimationFrame(() => {clampMegaMenu($menu);});
        }
    });
    // Header
   
    if($('#cart-upsell-block .cart-upsell-block-toggle').length > 0){
        $(document).on('click','#cart-upsell-block .cart-upsell-block-toggle',function(e){
            e.preventDefault();
            $(this).parents('#cart-upsell-block').toggleClass('active_upsell');
        });
    }

    if($('#cart-upsell-block .cart-upsell-block-head').length > 0){
        $(document).on('click','#cart-upsell-block .cart-upsell-block-head',function(e){
            e.preventDefault();
            if($(window).width() < 769){
                $(this).toggleClass('open_upsell');
                $(this).parents('#cart-upsell-block').find('.cart-upsell-block-content').slideToggle();
            }
        });
    }


    if($('.buy_with-product-select').length > 0){
        $(document).on("click", ".buy_with-product-select .buy_with-product-select-label", function (e) {
            e.stopPropagation();
            var $selectBox = $(this).closest(".buy_with-product-select");
            $(".buy_with-product-select").not($selectBox).removeClass("open");
            $selectBox.toggleClass("open");
        });

        $(document).on("click", function () {
            $(".buy_with-product-select").removeClass("open");
        });


        $(document).on("change", ".buy_with-product-select-opt", function () {
            var selectedText = $(this).text();
            $(this).closest(".buy_with-product-select").find(".buy_with-product-select-label span").text(selectedText);
        });
    }



    if($('.featured-collections-slider').length > 0){
        var featured_collections_slider = new Swiper(".featured-collections-slider", {
            slidesPerView: 'auto',
            spaceBetween: 20,
            navigation: {
                nextEl: ".featured-collections-slider .swiper-button-next",
                prevEl: ".featured-collections-slider .swiper-button-prev",
            },
            scrollbar: {
                el: ".swiper-scrollbar"
            },
        });
    }

    if($('.featured-collection-slider').length > 0){
        var featured_collection_mode = $(".featured-collection-slider").hasClass("desktop_slide") ? "desktop" :
                                       $(".featured-collection-slider").hasClass("mobile_slide") ? "mobile" :
                                       $(".featured-collection-slider").hasClass("mobile_desktop_both") ? "both" : "grid_view";
        var featured_collection_slider = null;

        function featured_collection_slider_swiper() {
            var isDesktop = $(window).width() >= 768

            if ((featured_collection_mode === "desktop" && isDesktop) || (featured_collection_mode === "mobile" && !isDesktop) || featured_collection_mode === "both") {
                if (!featured_collection_slider) {
                    featured_collection_slider = new Swiper(".featured-collection-slider", {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        navigation: {
                            nextEl: ".featured-collection-slider .swiper-button-next",
                            prevEl: ".featured-collection-slider .swiper-button-prev",
                        },
                        scrollbar: {
                            el: ".swiper-scrollbar"
                        },
                    });
                }
            } else {
                if (featured_collection_slider){
                    featured_collection_slider.destroy(true, true);
                    featured_collection_slider = null;
                }
            }
        }
        featured_collection_slider_swiper();
        $(window).on("resize", featured_collection_slider_swiper);
    }
  
  
    $('body').on('change', '.add_ons_checkbox input', function() {
        const $parent = $(this).parents('.buy_with-product');
        const $addon = $parent.find('.add_on_id');
        if ($(this).is(':checked')) {
            $addon.removeAttr('disabled');
        } else {
            $addon.attr('disabled', 'disabled');
        }
    });

    if($('.page-collection-list').length > 0){
        $('.collection-view-btn').click(function(e){
            e.preventDefault();
            var view = $(this).data('view');
            $(this).addClass('active');
            $(this).siblings('.collection-view-btn').removeClass('active');
            $(this).parents('.page-collection-list').find('.collection-list-row').attr('data-view',view);
        });
    }


    
    // var collection_swatch_blocks = new Swiper(".collection-swatch-blocks", {
    //   slidesPerView: 5,
    //   thumbs: {
    //     swiper: media_block_item_list,
    //   },
    // });
    // var media_block_item_list = new Swiper(".media-block_item-list", {
    //   effect: "fade",
    //   freeMode: true,
    //   watchSlidesProgress: true,
    //   thumbs: {
    //     swiper: collection_swatch_blocks,
    //   },
    // }); 
    // document
    // .querySelectorAll(".collection-swatch-blocks .swiper-slide")
    // .forEach((slide, index) => {
    //     slide.addEventListener("mouseenter", () => {
    //     media_block_item_list.slideTo(index);
    //     });
    // });
    // $('body').on('click', '.collection-facet-dropdown-header', function (e) {
    //     e.preventDefault();
    //     $('.collection-facet-dropdown-header').removeClass('is-active');
    //     $(this).addClass('is-active');
    // });
    // Toggle active on header click
    // $('body').on('click', '.collection-facet-dropdown-header', function (e) {
    //     e.stopPropagation(); // prevent body click from firing
    //     $('.collection-facet-dropdown-header').removeClass('is-active');
    //     $(this).addClass('is-active');
    // });
    // $('body').on('click', function () {
    //     $('.collection-facet-dropdown-header').removeClass('is-active');
    // });
    $('body').on('click', '.collection-facet-dropdown-header', function (e) {
        e.stopPropagation();

        const $this = $(this);

        // Close others
        $('.collection-facet-dropdown-header').not($this).removeClass('is-active');

        // Toggle current
        $this.toggleClass('is-active');
    });

    // Click outside → close all
    $('body').on('click', function () {
        $('.collection-facet-dropdown-header').removeClass('is-active');
    });


});
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".collection-list-block").forEach((section) => {
        const swatchEl = section.querySelector(".collection-swatch-blocks");
        const mediaEl = section.querySelector(".media-block_item-list");
        const nextArrow = section.querySelector(".media-block-swiper-button-next");
        const prevArrow = section.querySelector(".media-block-swiper-button-prev");
        const colorNameEl = section.querySelector(".swatch_active_color_name");

        if (!swatchEl || !mediaEl) return;

        let initialIndex = parseInt(mediaEl.dataset.index || 0, 10);

        function updateColorName(index) {
            const activeSlide = mediaEl.querySelectorAll(".swiper-slide")[index];
            if (!activeSlide) return;

            const link = activeSlide.querySelector("[data-swatch_name]");
            if (!link) return;

            const swatchName = link.getAttribute("data-swatch_name");
            if (colorNameEl && swatchName) {
                colorNameEl.textContent = swatchName;
            }
        }

        // THUMBS swiper
        const swatchSwiper = new Swiper(swatchEl, {
            slidesPerView: 5,
            watchSlidesProgress: true,
            slideToClickedSlide: true
        });

        // MAIN swiper
        const mediaSwiper = new Swiper(mediaEl, {
            effect: "fade",
            fadeEffect: { crossFade: true },
            watchSlidesProgress: true,
            allowTouchMove: false,
            initialSlide: initialIndex,
            navigation: {
                nextEl: nextArrow,
                prevEl: prevArrow,
            },
            thumbs: {
                swiper: swatchSwiper,
            },

            on: {
                init: function () {
                    updateColorName(this.activeIndex);
                },
                slideChange: function () {
                    updateColorName(this.activeIndex);
                }
            }

        });

        // Hover (desktop)
        swatchEl.querySelectorAll(".swiper-slide-collection-swatch-block").forEach((slide, index) => {
            slide.addEventListener("mouseenter", () => {
                if (mediaSwiper && mediaSwiper.slideTo) {
                    mediaSwiper.slideTo(index);
                }
            });
            // remove active class from all
            swatchEl.querySelectorAll(".swiper-slide-collection-swatch-block").forEach((s) => {
                s.classList.remove("swiper-slide-active");
            });

            // add active class to hovered slide
            slide.classList.add("swiper-slide-active");
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('backToTop');
  if (!btn) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 100) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  });

  btn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});